// extracted by mini-css-extract-plugin
export default {"preWrap":"CheckoutReminderSettings_preWrap__wA8jt"};